<div
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  class="content-module vocabulary-module"
>
  <ul class="vocable__list grid grid--4col">
    <li
      class="vocable__item"
      *ngFor="let vocabulary of module.vocabularies; let i = index;"
      [attr.data-has-audio]="!!vocabulary.audio"
      [attr.data-has-translation]="!!vocabulary.translation"
      [attr.data-has-image]="!!vocabulary.image"
    >
      <img
        class="vocable__image"
        [src]="vocabulary.image.url"
        [alt]="vocabulary.image.alt"
        *ngIf="vocabulary.image"
        (click)="playAudio(i)"
      >
      <div class="vocable__bottom">
        <svg class="vocable__sticker" *ngIf="vocabulary.audio" (click)="playAudio(i)">
          <use xlink:href="#sticker--speaker"></use>
        </svg>
        <div class="vocable__texts">
          <h5 class="vocable__name">
            {{ vocabulary.name }}
          </h5>
          <div class="vocable__translation" *ngIf="vocabulary.translation">
            {{ vocabulary.translation }}
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
